import './App.css';
import { ScriptsComponent } from './components/common/loadscripts.components';
import AddCategoryComponent from './components/dashboard/category/addcategory.component';
import CategoryComponent from './components/dashboard/category/category.component';
import AddStateComponent from './components/dashboard/states/addstate.component';
import StateComponent from './components/dashboard/states/state.component';
import AddUserRoleComponent from './components/dashboard/userrole/adduserrole.component';
import UserRoleComponent from './components/dashboard/userrole/userrole.component';
import LoginComponent from './pages/user/login.component';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/common/layout/layout';
import UsersComponent from './components/dashboard/users/users.component';
import AddUserComponent from './components/dashboard/users/adduser.component';
import ItemsComponent from './components/dashboard/items/items.component';
import AddItemsComponent from './components/dashboard/items/additems.component';
import CompanyComponent from './components/dashboard/company/company.component';
import DashboardComponent from '../src/pages/dashboard.component'
import AddCountryComponent from './components/dashboard/countries/addcountry.component';
import CountryComponent from './components/dashboard/countries/country.component';
import LeadSourcesComponent from './components/dashboard/leadsources/leadsources.component';
import AddLeadSourceComponent from './components/dashboard/leadsources/addleadsources.component';
import ModulesComponent from './components/dashboard/modules/modules.component';
import AddModulesComponent from './components/dashboard/modules/addmodules.component';
import StatusComponent from './components/dashboard/statuses/status.component';
import AddStatusComponent from './components/dashboard/statuses/addstatus.component';
import PrioritiesComponent from './components/dashboard/priorities/priorities.component';
import AddPrioritiesComponent from './components/dashboard/priorities/addpriorities.component';
import ProbabilityComponent from './components/dashboard/probability/probability.component';
import AddProbabilityComponent from './components/dashboard/probability/addprobability.component';
import TaxGroupComponent from './components/dashboard/taxgroups/taxgroup.component';
import AddTaxGroupComponent from './components/dashboard/taxgroups/addtaxgroup.component';
import ScrollButton from './components/common/scrollbar button/scrollbar.component';
import TendersComponent from './components/dashboard/tender/tender.component';
import AddTenderComponent from './components/dashboard/tender/addtender.component';
import LeadsComponent from './components/dashboard/leads/leads.component';
import AddLeadComponent from './components/dashboard/leads/addleads.component';
import CustomersComponent from './components/dashboard/customers/customer.component';
import AddCustomerComponent from './components/dashboard/customers/addcustomer.component';
import ActivityComponent from './components/dashboard/activity/activity.component';
import AddActivityComponent from './components/dashboard/activity/addactivity.component';
import InvoiceComponent from './components/dashboard/invoice/invoice.component';
import ServiceComponent from './components/dashboard/service_component/service.component';
import AddInvoiceComponent from './components/dashboard/invoice/addinvoice.component';
import AddServicesComponent from './components/dashboard/service_component/addservices.component';
import QuotesComponent from './components/dashboard/quotes/quotes.component';
import AddQuoteComponent from './components/dashboard/quotes/addquotes.component';
import ServicesSearch from './components/dashboard/services_search/search.component';
import MyTeamComponent from './components/dashboard/myteam/myteam.component';
import SummaryComponent from './components/dashboard/summary/summary.component';
import DashboardDetailsComponent from './components/dashboard/dashboarddetails/dashboarddetails.component';
import ProfileComponent from './components/dashboard/profile/profile.component';
import PrivateRoute from './components/common/privateroute';

function App() {
  return (
    <Router>
      <div className="App">
        <ScriptsComponent />
        <Routes>
          <Route
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route path="/dashboard" element={<DashboardComponent />} />
            <Route path="/dashboard/" element={<SummaryComponent />} />
            <Route path="/dashboarddetails/" element={<DashboardDetailsComponent />} />

            <Route path="/myteam" element={<MyTeamComponent />} />
            <Route path="/profile" element={<ProfileComponent />} />

            <Route path="/services/search" element={<ServicesSearch />} />

            <Route path="/quotes" element={<QuotesComponent />} />
            <Route path="/quote/create" element={<AddQuoteComponent />} />
            <Route path="/quote/edit" element={<AddQuoteComponent />} />

            <Route path="/service" element={<ServiceComponent />} />
            <Route path="/service/create" element={<AddServicesComponent />} />
            <Route path="/service/edit" element={<AddServicesComponent />} />

            <Route path="/invoice" element={<InvoiceComponent />} />
            <Route path="/invoice/create" element={<AddInvoiceComponent />} />
            <Route path="/invoice/edit" element={<AddInvoiceComponent />} />

            <Route path="/activity" element={<ActivityComponent />} />
            <Route path="/activity/create" element={<AddActivityComponent />} />
            <Route path="/activity/edit" element={<AddActivityComponent />} />

            <Route path="/customer" element={<CustomersComponent />} />
            <Route path="/customer/create" element={<AddCustomerComponent />} />
            <Route path="/customer/edit" element={<AddCustomerComponent />} />

            <Route path="/leads" element={<LeadsComponent />} />
            <Route path="/leads/create" element={<AddLeadComponent />} />
            <Route path="/leads/edit" element={<AddLeadComponent />} />

            <Route path="/tenders" element={<TendersComponent />} />
            <Route path="/tender/create" element={<AddTenderComponent />} />
            <Route path="/tender/edit" element={<AddTenderComponent />} />

            <Route path="/taxgroup" element={<TaxGroupComponent />} />
            <Route path="/taxgroup/create" element={<AddTaxGroupComponent />} />
            <Route path="/taxgroup/edit" element={<AddTaxGroupComponent />} />

            <Route path="/probability" element={<ProbabilityComponent />} />
            <Route path="/probability/create" element={<AddProbabilityComponent />} />
            <Route path="/probability/edit" element={<AddProbabilityComponent />} />

            <Route path="/priorities" element={<PrioritiesComponent />} />
            <Route path="/priorities/create" element={<AddPrioritiesComponent />} />
            <Route path="/priorities/edit" element={<AddPrioritiesComponent />} />

            <Route path="/statuses" element={<StatusComponent />} />
            <Route path="/statuses/create" element={<AddStatusComponent />} />
            <Route path="/statuses/edit" element={<AddStatusComponent />} />

            <Route path="/leadsources" element={<LeadSourcesComponent />} />
            <Route path="/leadsources/create" element={<AddLeadSourceComponent />} />
            <Route path="/leadsources/edit" element={<AddLeadSourceComponent />} />

            <Route path="/company" element={<CompanyComponent />} />

            <Route path="/users" element={<UsersComponent />} />
            <Route path="/users/create" element={<AddUserComponent />} />
            <Route path="/users/edit" element={<AddUserComponent />} />

            <Route path="/state" element={<StateComponent />} />
            <Route path="/state/create" element={<AddStateComponent />} />
            <Route path="/state/edit" element={<AddStateComponent />} />

            <Route path="/modules" element={<ModulesComponent />} />
            <Route path="/modules/edit" element={<AddModulesComponent />} />
            <Route path="/modules/create" element={<AddModulesComponent />} />

            <Route path="/category" element={<CategoryComponent />} />
            <Route path="/category/create" element={<AddCategoryComponent />} />
            <Route path="/category/edit" element={<AddCategoryComponent />} />

            <Route path="/userrole" element={<UserRoleComponent />} />
            <Route path="/userrole/create" element={<AddUserRoleComponent />} />
            <Route path="/userrole/edit" element={<AddUserRoleComponent />} />

            <Route path="/country" element={<CountryComponent />} />
            <Route path="/country/edit" element={<AddCountryComponent />} />
            <Route path="/country/create" element={<AddCountryComponent />} />

            <Route path="/items" element={<ItemsComponent />} />
            <Route path="/items/create" element={<AddItemsComponent />} />
            <Route path="/items/edit" element={<AddItemsComponent />} />
          </Route>

          <Route path="/" element={<LoginComponent />} />


        </Routes >

        <ScrollButton />
      </div >
    </Router >
  );
}

export default App;
